export const LOAD_ESTADOS = 'LOAD_ESTADOS';
export const ESTADO_ERROR = 'ESTADO_ERROR';
export const ESTADO_GET_ERRORS = 'ESTADO_GET_ERRORS';
export const ESTADOS_DATA = 'ESTADOS_DATA';
export const STORE_ESTADO = 'STORE_ESTADO';
export const GET_ESTADO = 'GET_ESTADO';
export const REMOVER_ESTADO = 'REMOVER_ESTADO';
export const SHOW_ESTADO = 'SHOW_ESTADO';
export const UPDATE_ESTADO = 'UPDATE_ESTADO';
